import { Container, Row, Col } from "react-bootstrap"
import MenuMarketplace from "../../components/menus/MenuMarketplace"
import { useTranslation } from 'react-i18next'

export default function OperationOK() {
    const { t } = useTranslation()

    return(
        <>
            <MenuMarketplace section='operation'/>
            <Container className="vh-100 d-flex justify-content-center align-items-center">
                <Row>
                    <Col className="d-flex flex-column justify-content-center align-items-center">
                        <img src="/images/operationOK.svg" alt="Operation OK" />
                        <h2 className="my-3">{t("global.operationOK")}</h2>
                        <p dangerouslySetInnerHTML={{ __html: t("global.operationOKphrase") }} className="text-center"/>
                        <p dangerouslySetInnerHTML={{ __html: t("global.operationOKphrase2") }} className="text-center"/>                        
                    </Col>
                </Row>
            </Container>
        </>
    )
}